export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',

  // Empty Merchants
  'components.emptyMerchants.title': '欢迎使用 AimerPay！',
  'components.emptyMerchants.subtitle':
    '您还没有创建任何商户。让我们开始创建您的第一个商户账户吧。',
  'components.emptyMerchants.createButton': '创建您的第一个商户',
  'components.emptyMerchants.stepsTitle': '快速入门',
  'components.emptyMerchants.step1.title': '创建商户账户',
  'components.emptyMerchants.step1.description':
    '提供基本的商业信息，包括法定名称、国家和联系方式。',
  'components.emptyMerchants.step2.title': '完成 KYC 验证',
  'components.emptyMerchants.step2.description':
    '通过 Adyen Hosted Onboarding 提交所需的商业文件以进行合规验证。',
  'components.emptyMerchants.step3.title': '开始管理支付',
  'components.emptyMerchants.step3.description':
    '验证通过后，您可以创建商店、查看交易、处理支付并管理您的余额账户。',
  'components.emptyMerchants.helpText':
    '需要帮助吗？我们的支持团队随时为您提供入门流程的协助。',

  // Acting as MerchantOwner Banner
  'component.actingAsMerchantOwner.label': '正在以 {name} 身份操作',
  'component.actingAsMerchantOwner.exit': '返回管理后台',

  // Merchant workspace back-to-list sidebar item
  'component.merchantWorkspace.backToList': '返回商户列表',
  'component.backToWorkspace.merchants': '返回商户列表',
  'component.backToWorkspace.admin': '返回管理后台',
};
